import { useEffect, useState } from 'react';

const API_URL = import.meta.env.VITE_API_BASE;

interface VersionInfo {
  version: string;
  name?: string;
}

export default function VersionDisplay({ className = "" }: { className?: string }) {
  const [version, setVersion] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Try to get version from build-time injection first
    const buildVersion = import.meta.env.VITE_APP_VERSION;
    if (buildVersion) {
      setVersion(buildVersion);
      setLoading(false);
      return;
    }

    // Fallback to API
    async function fetchVersion() {
      try {
        const res = await fetch(`${API_URL}/api/version`);
        if (res.ok) {
          const data: VersionInfo = await res.json();
          setVersion(data.version);
        } else {
          setVersion('unknown');
        }
      } catch (error) {
        setVersion('unknown');
      } finally {
        setLoading(false);
      }
    }

    fetchVersion();
  }, []);

  if (loading) {
    return null;
  }

  return (
    <div 
      className={`text-xs text-text-dim text-center ${className}`}
      data-testid="version-display"
      title={`App version: ${version}`}
    >
      v{version}
    </div>
  );
}
